/**
 * created by lei lei
 * 图片本地上传
 */
import React, {Component} from 'react';
import {Icon, Tooltip, Switch, InputNumber,message} from "antd";
import './ImagesLocally.scss'
import {PIC_TYPE, PIC_TYPE_ORIGINAL} from "../../../../constants";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import UploadWall from "../../../../components/upload/UploadWall";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";
import leftSideIcon from '../image/leftside.png';
import leftCenterIcon from '../image/leftCenter.png';
import rightCenterIcon from '../image/rightCenter.png';
import centerIcon from '../image/center.png';
import NormalFileItem from "../../../../components/upload/fileItem/PictureNormalFileItem";
import {unitConvert} from "../../../../utils";

export default class ImagesLocally extends BaseComponent {

    static defaultProps = {
        onChange: ()=>{}
    };

    constructor(props) {
        super(props);
        this.state = {
            cssWidth: 0,
            cssMargin: 0,
            cssBorder: 0,
            cssWater: eval(this.sysConfigGetValueByKey("editor.content.pic.insert.water.open", "false")),
            fileList: [],
            previewVisible:false,
            float: null,
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp'],
            newPicAccept:[],
            waterPicList:[],
        };
        this.getAllWaterPicData();
    }

    //获取所有水印图片数据
    getAllWaterPicData = ()=>{
        this.request({
            url: '/storage/watermark/list',
            callBack: (waterPicList) => {
                this.setState({waterPicList});
            }
        });
    };

    onChange = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.props.onChange(JSON.parse(JSON.stringify(info.fileList)));
        this.setState({
            fileList: info.fileList
        })
    };

    handleRemove =  file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.props.onChange(JSON.parse(JSON.stringify(fileList)));
        this.setState({
            fileList
        },()=>{
        });
    };


    handlePreview = file => {
        if(file && file.url){
            this.setState({
                previewImage: file.url,
                previewVisible: true,
            });
        }
    };

    beforeUpload = async file => {
        this.state.newPicTypeList = [...this.state.newPicType,...this.state.newPicType.toUpperCase()]
        let res = this.state.newPicTypeList.find(item=>file.name.endsWith(item));
        return new Promise((resolve, reject) => {
            if(res){
                resolve(file);
            }else{
                message.error('暂不支持该文件类型！');
                reject();
            }
        });
    };
    componentDidMount() {
        // this.state.newPicType = PIC_TYPE_ORIGINAL.filter((item)=>{
        //     return item.indexOf("webp")===-1;})
        //
        // let spliceAccept = PIC_TYPE.filter((item)=>{
        //     return item.indexOf("webp")===-1 && item.indexOf("WEBP")===-1;})
        // this.state.newPicAccept = spliceAccept.join(",.")
    }

    render() {
        let {fileList} = this.state;
        return (
            <div className="lightLoupe">
                {this.header()}
                {this.main()}
                {fileList && fileList.length > 0 &&  this.footer()}
            </div>
        )
    }

    header() {
        let {fileList} = this.state;
        let fileLength = fileList ? fileList.length : 0;
        let allSize = 0;
        fileList && fileList.map(file=>{
            allSize += file.originFileObj.size;
        });
        let baseStyle = {marginLeft:15,cursor:"pointer"};
        let defaultStyle = {...baseStyle,border:"1px solid #FFF"};
        let checkedStyle = {...baseStyle,borderTop:"solid 1px #000",borderLeft:"solid 1px #000",borderRight:"solid 1px #DCDCDC",borderBottom:"solid 1px #DCDCDC"};
        let text = this.sysConfigGetValueByKey("editor.picture.upload.dialog.remind.txt", `图片格式要求：${this.state.newPicType.join("，")}`);

        return (
            <div className="pictureFormat">
                <div className={"text-pointer"} style={{maxWidth:400,color:"#F56C6C"}}>
                    <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
                </div>
                <div>
                    {fileLength > 0 && <span style={{color:"#9b9999"}}>共<span style={{margin:"0 5px"}}>{fileLength}</span>张（{unitConvert(allSize)}）</span>}
                    <span style={{color:"#000",marginLeft:15}}>图片浮动方式：</span>
                    <Tooltip placement="top" title={"无浮动"} onClick={()=>{this.setState({float:null})}}><img style={this.state.float===null?checkedStyle:defaultStyle} src={leftSideIcon}/></Tooltip>
                    <Tooltip placement="top" title={"左浮动"} onClick={()=>{this.setState({float:"left"})}}><img style={this.state.float==="left"?checkedStyle:defaultStyle} src={leftCenterIcon}/></Tooltip>
                    <Tooltip placement="top" title={"右浮动"} onClick={()=>{this.setState({float:"right"})}}><img style={this.state.float==="right"?checkedStyle:defaultStyle} src={rightCenterIcon}/></Tooltip>
                    <Tooltip placement="top" title={"居中独占一行"} onClick={()=>{this.setState({float:"center"})}}><img style={this.state.float==="center"?checkedStyle:defaultStyle} src={centerIcon}/></Tooltip>
                </div>
            </div>
        )
    }

    footer() {
        let defaultWidth = this.sysConfigGetValueByKey("editor.content.pic.insert.width", "500");
        let defaultWaterPic = this.state.waterPicList && this.state.waterPicList.find(water=>water.status === 1);
        if(!defaultWaterPic){
            this.state.cssWater=false;
        }
        return (
                <table style={{marginBottom:10}} width={"100%"} cellSpacing={0} cellPadding={0} border={0}><tbody><tr>
                    <td>
                        <div className="seat">
                            <div>宽度（px）</div>
                            <InputNumber min={1} max={100000} defaultValue={parseInt(defaultWidth)} onChange={(value)=>{this.inputNumberOnChange(value, 'cssWidth')}} />
                            <div style={{marginLeft: 10}}>边距（px）</div>
                            <InputNumber min={0} max={100000} defaultValue={0} onChange={(value)=>{this.inputNumberOnChange(value, 'cssBorder')}} />
                            <div style={{marginLeft: 10}}>边框（px）</div>
                            <InputNumber min={0} max={100000} defaultValue={0} onChange={(value)=>{this.inputNumberOnChange(value, 'cssMargin')}} />
                        </div>
                    </td>
                    <td width={140}>
                        {defaultWaterPic && <div className="watermark">
                            <div style={{marginRight:10}}>图片水印设置</div>
                            <Switch checkedChildren="开" unCheckedChildren="关" defaultChecked={this.state.cssWater} onChange={(value)=>{this.inputNumberOnChange(value, 'cssWater')}}/>
                        </div>}
                    </td>
                </tr></tbody></table>
        )
    }
    main() {
        const {fileList} = this.state;
        // if(fileList.length > 0) {
            return (
                <div className='noFile'>
                    <div style={{height: '100%', width: '100%',}} onClick={()=>{
                        // let dom = $("input[type='file']").click();
                    }}>
                        <Scrollbars
                            autoHeight={true}
                            autoHeightMax={300}
                        >
                            <div style={{paddingRight:10}}>
                                {this.upload()}
                            </div>
                        </Scrollbars>
                        {fileList.length === 0 &&
                        <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={"80%"}><tbody><tr><td valign={"middle"} align={"center"}>
                            <div className="noPictures"></div>
                            <div onClick={()=>this.uploadWall && this.uploadWall.uploadDisplayBtnClick()} style={{cursor:"pointer",borderRadius: 8,width:100,padding:5,border:`1px solid ${this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}`, color:`${this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}`}}>
                                点击选择图片
                            </div>
                        </td></tr></tbody></table>}
                    </div>
                </div>
            )
    }

    upload() {
        const {fileList} = this.state;
        return (
            <UploadWall
                ref={uploadWall=>this.uploadWall = uploadWall}
                showUploadDisplayBtn={true}
                accept={"."+this.state.newPicType.join(",.")}
                multiple={true}
                action="/storage/uploadFile"
                fileList={fileList}
                style={{padding:'unset'}}
                uploadBtnComponent={(size)=>{
                    return <table style={{background:"#f4f6fc",border:"1px solid #f1f3f4",cursor:"pointer"}} cellSpacing={0} cellPadding={0} width={size} height={size}><tbody><tr><td valign={"middle"} align={"center"}>
                        <Icon type={"plus"} style={{color:"#5a5858",fontSize:16,margin:10}}></Icon><br/>
                        <span style={{color:"#9ca0a3",fontSize:14}}>点击上传</span>
                    </td></tr></tbody></table>
                }}
                customRequest={new ChunkUpload({
                    checkFileURL:"/storage/checkFile",
                    checkChunkURL:"/storage/checkChunk",
                    uploadChunkURL:"/storage/uploadChunk",
                    chunkUploadOverURL:"/storage/chunkIsUploadOver",
                    mergeChunksURL:"/storage/mergeChunk",
                    fileError:(md5)=>{
                        let file = fileList.find(item=>item.md5 === md5);
                        message.error("文件上传错误！")
                    }
                }).start}
                icons={["eye", "download", "delete"]}
                fileItemComponent={NormalFileItem}
                isSyncModifiedFileName={true}   //通过服务端修改文件名
                onEditFileNameCall={(file, fileName)=>{
                    this.state.fileList.forEach(item=>{
                        if(item.id === file.id) {
                            item.name = fileName
                            // item.originFileObj.name = fileName
                        }
                    })
                    this.setState({},()=>{
                        this.props.onChange(this.state.fileList)
                    });
                }}
                showUploadBtn={fileList.length !== 0}
                uploadBtnName={"点击上传"}
                beforeUpload={this.beforeUpload}
                onChange={this.onChange}
                onRemove={this.handleRemove}
                onPreview={this.handlePreview}
            />
        )
    }

    inputNumberOnChange (value, type='width') {
        this.state[type] = value;
        // this.setState({});
    }

}